import { ReactNode, useContext } from "react";
import {
  TitleContext,
  TitleDescriptionContext,
} from "@common/context/ThemeContext";
import { __ } from "@common/helpers/i18n";
import { useDocumentDirection } from "@app/hooks";
import HeaderThemeToggle from "./HeaderThemeToggle";
import HeaderUser from "./HeaderUser";
import Notification from "./Notification";

export default function Header({ children }: { children?: ReactNode }) {
  const title = useContext(TitleContext);
  const description = useContext(TitleDescriptionContext);
  const direction = useDocumentDirection();

  return (
    <header
      className="relative z-header hidden h-16 flex-shrink-0 items-center border-b border-border bg-card md:flex"
      dir={direction}
    >
      <div className="flex min-w-0 flex-1 items-center justify-between gap-5 px-6">
        <div className="min-w-0">
          <h1 className="truncate text-lg font-extrabold leading-7 tracking-normal text-foreground">
            {title}
          </h1>
          <p className="mt-0.5 max-w-3xl truncate text-xs font-medium leading-4 text-muted-foreground">
            {description ||
              __("%{site} workspace", {
                site: __(import.meta.env.VITE_SITE_NAME),
              })}
          </p>
        </div>

        <div className="flex flex-shrink-0 items-center gap-2">
          {children}
          <HeaderThemeToggle />
          <Notification />
          <div className="mx-1.5 h-8 w-px bg-border" />
          <HeaderUser />
        </div>
      </div>
    </header>
  );
}
